import stickyStyles from '@github-ui/use-sticky-header/use-sticky-header.module.css'
import {useStickyHeader} from '@github-ui/use-sticky-header/useStickyHeader'
import {clsx} from 'clsx'
import {VerifiedHTMLText} from '@github-ui/safe-html/VerifiedHTML'
import type {PullRequest} from '../types'
import {StateIcon} from './StateIcon'
import styles from './PullRequestMiniHeader.module.css'

export interface PullRequestMiniHeaderProps {
  pullRequest: PullRequest
}

export function PullRequestMiniHeader({pullRequest}: PullRequestMiniHeaderProps) {
  const {isSticky, sensorRef} = useStickyHeader()

  return (
    <>
      <div className={clsx(stickyStyles.stickyHeader, styles.miniHeader, isSticky && styles['is-stuck'])}>
        <StateIcon state={pullRequest.state} />
        <span className={clsx(styles.number, 'f5 fgColor-muted')}>#{pullRequest.number}</span>
        <span className={clsx(styles.title, 'f5 text-bold fgColor-default')}>
          <VerifiedHTMLText className="markdown-title" html={pullRequest.titleHtml} />
        </span>
      </div>
      <div ref={sensorRef} className={styles.stickyHeaderSentinel} />
    </>
  )
}
